import { FC, useEffect } from "react";
import { I_formNode, useForm } from "./../../../components/aio/aio-input";
import { I_model, I_type } from "../types";
import Icon from '@mdi/react';
import { mdiInformationOutline } from "@mdi/js";
import { useFreelancerProvider } from "../context";
export const NumbersForm: FC<{
    data: I_model,
    onChange: (v: I_model) => void,
    setDisabled: (v: boolean) => void,
    type: I_type
}> = (props) => {
    const {inputCls} = useFreelancerProvider()
    const form = useForm<I_model>({
        data: props.data, fa: true, showErrors: false,
        onChange: (data) => props.onChange(data),
        option: {
            required: ({ input }) => {
                if (input.field === "drivingLicenceNo") {
                    return [0, 2, 4].indexOf(props.type) !== -1
                }
                return true
            },
            labelType: () => "online",
            className:()=>inputCls
        },
        validations: {
            iban: ({ inputName, value }) => {
                if (value && value.length < 24) {
                    return `شماره شبا باید 24 رقم باشد`
                }
            }
        },
        inputs: {
            drivingLicenceNo: { field: 'drivingLicenceNo', label: 'شماره گواهینامه', type: 'text' },
            iban: {field: 'iban',label: 'شماره شبا',type: 'text',after: 'IR',filter: ['number'],style: { direction: 'ltr' },maxLength: 24,validation: ['iban']},
            bankPaperNo: { field: 'bankPaperNo', label: 'شماره سفته', type: 'text' },
            contractNo: { field: 'contractNo', label: 'شماره قرارداد', type: 'text' }
        },
    })
    useEffect(() => {
        props.setDisabled(!!form.disabled)
    }, [form.disabled])
    const rowCls = 'p-v-12- gap-16-'
    const node: I_formNode<I_model> = {
        className: 'gap-16-',
        v: [
            {
                className: rowCls,
                h: [
                    { className:'flex-1', input: 'drivingLicenceNo' },
                    { className:'flex-1', input: 'iban' },
                    { className:'flex-1', input: 'bankPaperNo' },
                    { className:'flex-1', input: 'contractNo' }
                ]
            }
        ]
    }
    return (
        <>
            {form.render.layout(node)}
            {
                form.errorsList.length > 0 &&
                <div className="fs-12- m-t-8- p-h-12- flex-row- align-v- gap-6-" style={{ color: 'red' }}>
                    <Icon path={mdiInformationOutline} size={0.8} color='red' />
                    {form.errorsList[0]}
                </div>
            }
        </>
    )
}










































